import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';

import { OrdersService } from '../../../../services/orders';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { isPlatformBrowser } from '@angular/common';
import { BundleService } from '../../../../services/bundles';

@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrl: './orderdetails.component.scss'
})
export class OrderdetailsComponent implements OnInit {

  contentReady = false;
  isAr = false;

  data!: any;
  invoiceId!: any;
  date!: any;
  address!: any;

  products: number[] = [];
  qty: number[] = [];
  orderLines: any[] = [];
  deliveryfees!: any;
  discount!: any;
  total!: number;

  delivery_hero!: any;
  order_location!: string;
  order_status!: number;

  allData: any[] = [];

  private isBrowser: boolean;

  constructor(
    private _orderService: OrdersService,
    private route: ActivatedRoute,
    private _slugify: UrlSlugifyService,
    private router: Router,
    private bundleService: BundleService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }


  ngOnInit(): void {
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.route.queryParams.subscribe(params => {
      this.invoiceId = params['id'];

      if (this.invoiceId) {
        this.getOrderById(this.invoiceId);
      }
    });
  }

  getOrderById(orderId: any) {
    this.contentReady = true;

    this._orderService.getOrderById(orderId).subscribe({
      next: (res) => {
        this.data = res;

        const items = String(res.item || '').split(',');
        const qty = String(res.quantity || '').split(',');
        const prices = String(res.price || '').split(',');
        const productIds = String(res.product_id || '').split(',');

        this.orderLines = items.map((name: string, index: number) => ({
          name: name?.trim(),
          qty: Number(qty[index] || 0),
          price: Number(prices[index] || 0),
          total: Number(qty[index] || 0) * Number(prices[index] || 0),
          product_id: Number(productIds[index] || 0),
          product: null
        }));

        this.deliveryfees = parseInt(res.delivery_fees, 10) || 0;
        this.total = parseInt(res.total, 10) || 0;
        this.address = res.address;
        this.date = this.convertDate(res.created_at);
        this.order_status = parseInt(res.order_status, 10);
        this.order_location = res.order_location;
        this.delivery_hero = res.delivery_hero;

        // ✅ هات تفاصيل المنتجات عشان الصورة والضغط
        const validIds = this.orderLines
          .map(line => line.product_id)
          .filter((id: number) => !!id);

        const uniqueIds = [...new Set(validIds)];

        if (uniqueIds.length) {
          this.getProductsForLines(uniqueIds);
        } else {
          this.contentReady = false;
        }
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      }
    });
  }
  getProductsForLines(productIds: number[]): void {
    this._orderService.getByIds(productIds).subscribe({
      next: (data: any) => {
        const productMap = new Map<number, any>();

        data.forEach((product: any) => {
          productMap.set(Number(product.id), product);
        });

        this.orderLines = this.orderLines.map(line => ({
          ...line,
          product: productMap.get(line.product_id) || null
        }));

        this.contentReady = false;
      },
      error: (err) => {
        console.error("Error fetching products:", err);
        this.contentReady = false;
      }
    });
  }
  // ================= FETCH Bundle =================
  getBundle(bundleId: number, bundleQty: number): void {

    this.contentReady = true;

    this.bundleService.getById(bundleId).subscribe({
      next: (bundle: any) => {

        // 👇 ضيف Quantity للباندل
        bundle.orderQty = bundleQty;

        // 👇 ضيفه مع المنتجات
        this.allData.push(bundle);

        this.contentReady = false;
      },
      error: (err) => {
        console.error("Error fetching bundle:", err);
        this.contentReady = false;
      }
    });
  }

  // ================= FETCH PRODUCTS =================
  getProducts(products: number[]): void {
    this.contentReady = true;

    this._orderService.getByIds(products).subscribe({
      next: (data: any) => {

        // ✅ Merge بدل overwrite
        this.allData = [...this.allData, ...data];

        console.log("Order Items After Merge:", this.allData);

        this.contentReady = false;
      },
      error: (err) => {
        console.error("Error fetching products:", err);
        this.contentReady = false;
      }
    });
  }


  // ================= HELPERS =================

  fixImage(url: string): string {
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }

  openDetails(item: any): void {

    // ✅ لو Bundle
    if (item?.items?.length) {
      this.router.navigate([
        '/bundle',
        this._slugify.slugify(item.name_en),
        item.id
      ]);
    }

    // ✅ لو Product
    else {
      this.router.navigate([
        '/product',
        this._slugify.slugify(item.name_en),
        item.id
      ]);
    }
  }


  calcDis(newP: any, oldP: any): number | null {
    const off = Math.round(
      ((parseInt(oldP, 10) - parseInt(newP, 10)) / parseInt(oldP, 10)) * 100
    );
    return isNaN(off) ? null : off;
  }

  convertDate(dateString: any): string {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
}
